import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Wallet, Plus, History } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useWallet, fmtUsd } from "@/lib/wallet";
import { useAuth } from "@/lib/auth";
import DepositModal from "@/components/DepositModal";

export default function WalletBadge({ compact = false }) {
  const { t } = useTranslation();
  const { user, login } = useAuth();
  const { balance, tickets } = useWallet(user ? 15000 : 0);
  const [depOpen, setDepOpen] = useState(false);
  const navigate = useNavigate();

  if (!user) {
    return (
      <button onClick={login} data-testid="wallet-login-cta"
        className="inline-flex items-center gap-2 px-3 py-2 rounded-sm border border-primary/40 bg-black/50 hover:bg-primary/10 text-primary font-mono text-[10px] tracking-widest">
        <Wallet className="h-3.5 w-3.5" /> {t("header.login_cta")}
      </button>
    );
  }

  return (
    <>
      <div className={`inline-flex items-center gap-2 rounded-sm border border-primary/40 bg-black/60 backdrop-blur px-3 py-2 ${compact ? "" : "shadow-lg shadow-primary/10"}`} data-testid="wallet-badge">
        <Wallet className="h-3.5 w-3.5 text-primary" />
        <span className="font-mono text-xs tracking-widest text-primary" data-testid="wallet-balance">
          {fmtUsd(balance)} USDT
        </span>
        <span className="text-white/30 font-mono text-xs">·</span>
        <span className="font-mono text-xs tracking-widest text-amber-200 inline-flex items-center gap-1" data-testid="wallet-tickets" title="Tickets ativos">
          {tickets ?? 0} <span className="text-amber-200">🎟</span>
        </span>
        <button onClick={() => navigate("/carteira")} data-testid="wallet-history-btn" title="Histórico de transações"
          className="ml-1 p-1 rounded-sm border border-primary/40 hover:bg-primary/20 text-primary">
          <History className="h-3 w-3" />
        </button>
        <button onClick={() => setDepOpen(true)} data-testid="wallet-deposit-btn" title="Depositar USDT"
          className="p-1 rounded-sm border border-primary/40 hover:bg-primary/20 text-primary">
          <Plus className="h-3 w-3" />
        </button>
      </div>
      <DepositModal open={depOpen} onClose={() => setDepOpen(false)} />
    </>
  );
}
